import { Container, Col } from '@ui/wrapper'
import BoxImage from '@components/box-large-image/layout-07'
import { SectionWrapper, TitleWrapper, StyledTitle, StyledRow } from './style'

const MitgliederArea = ({ data, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        <StyledRow>
          <b>
            <TitleWrapper>
              <StyledTitle>{data.section_title?.title}</StyledTitle>
            </TitleWrapper>
          </b>
          {data.items.map((item, index) => (
            <Col
              key={'mitglieder-images-' + index.toString()}
              style={{ marginBottom: 20 }}
              lg={3}
              md={4}
            >
              <BoxImage
                desc={item.description}
                image={item.images[0]}
                path={item.images[0].path}
              />
            </Col>
          ))}
        </StyledRow>
      </Container>
    </SectionWrapper>
  )
}

export default MitgliederArea
